/* eslint-disable */
import { Space } from 'antd';
import React, { FC, useState, useRef } from 'react';
import { RangePicker } from 'components/molecules/range-picker';
import styled from 'styled-components';
import { Timestamp } from 'api/models';
import { toastService } from 'components/molecules/toast';

const MediumWidth = styled.div`
  width: 350px;
`;

export const DemoToast: FC = () => {
  const [date, setDate] = useState<[Timestamp | null, Timestamp | null]>([
    null,
    null,
  ]);
  const toastContainer = useRef<HTMLDivElement | null>(null);

  const showNotification = () => {
    const service = toastService({
      toastContainer,
      title: 'Toast title',
      message: 'Toast message. Target my `toastContainer` to style further.',
    });

    service.success();
  };

  return (
    <Space direction="vertical">
      <h3>Toast service</h3>
      <p>
        Toast is not a react component, but more of a wrapper around antd{' '}
        <strong>notification</strong> service. Not calling it 'Notification'
        because we've another notification feature
      </p>
      <button onClick={showNotification}>Click here to open up a toast</button>
      {/* You may need to add some styles to the parent to control native styling of antd notification  */}
      <div ref={toastContainer} />
    </Space>
  );
};
